import server from "@/api/server";

async function getAlerts() {
  let res = await server.get("/agent/agent/alerts/get");
  return res;
}
async function clearAlerts() {
  let res = await server.get("/agent/agent/alerts/clear");
  return res;
}
async function deleteAlert(id) {
  let res = await server.post("/agent/agent/alerts/delete", { id });
  return res;
}
async function refreshCountBackground(hideLoader = true) {
  let res = await server.get("/agent/agent/background/refresh", { hideLoader });
  return res;
}

export { getAlerts, deleteAlert, clearAlerts, refreshCountBackground };
